import { IonLabel, IonSpinner } from "@ionic/react";

interface SpinnerProps {
  activo: boolean;
  texto?: string;
}

const Spinner: React.FC<SpinnerProps> = (props: SpinnerProps) => {
  const staticClasses = "d-flex flex-centered-content animated-transition py-1";
  const visibilidad = props.activo ? "" : "opacity-0";

  return (
    <div className={`${staticClasses} ${visibilidad}`}>
      <IonSpinner name="bubbles" />{" "}
      <IonLabel>{props.texto ? props.texto : "Cargando..."}</IonLabel>
    </div>
  );
};

export default Spinner;
